export default "./dist/stdassets/images/icons/icon_refreshmap.png";